import React from "react";
import CustomSelect from "../../components/CustomSelect";
import AppInput from "../../components/ui/AppInput";
import { formatDateString, formatPhoneNumber } from "../../utils";

export default function StudentEditFormFields({
  formData,
  setFormData,
  allDepartments,
  theme,
}) {
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">
          이름 <span className="text-red-500">*</span>
        </label>
        <div className="flex gap-2">
          <AppInput
            id="student-edit-name"
            name="student_edit_name"
            required
            className="flex-1 font-bold"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            onClear={() => setFormData({ ...formData, name: "" })}
            placeholder="이름 입력"
          />
          <div className="flex bg-gray-100 p-1.5 rounded-2xl flex-shrink-0">
            <button
              type="button"
              onClick={() => setFormData({ ...formData, gender: "남" })}
              className={`px-4 rounded-xl text-sm font-bold transition-all ${
                formData.gender === "남"
                  ? "bg-white text-blue-600 shadow-sm ring-1 ring-black/5"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              남
            </button>
            <button
              type="button"
              onClick={() => setFormData({ ...formData, gender: "여" })}
              className={`px-4 rounded-xl text-sm font-bold transition-all ${
                formData.gender === "여"
                  ? "bg-white text-rose-500 shadow-sm ring-1 ring-black/5"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              여
            </button>
          </div>
        </div>
      </div>

      <div className="col-span-12 sm:col-span-6">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">생년월일</label>
        <AppInput
          id="student-edit-birth"
          name="student_edit_birth"
          placeholder="YYYY-MM-DD"
          value={formData.birth}
          onChange={(e) =>
            setFormData({ ...formData, birth: formatDateString(e.target.value) })
          }
          onClear={() => setFormData({ ...formData, birth: "" })}
        />
      </div>
      <div className="col-span-12 sm:col-span-6">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">연락처</label>
        <AppInput
          id="student-edit-phone"
          name="student_edit_phone"
          placeholder="010-0000-0000"
          value={formData.phone}
          onChange={(e) =>
            setFormData({ ...formData, phone: formatPhoneNumber(e.target.value) })
          }
          onClear={() => setFormData({ ...formData, phone: "" })}
        />
      </div>

      <div className="col-span-12">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">보호자1</label>
        <div className="flex gap-2">
          <input
            id="student-edit-guardian1-name"
            name="student_edit_guardian1_name"
            className="w-24 bg-white border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-[#354F38] focus:ring-4 focus:ring-[#354F38]/10 transition text-center"
            placeholder="관계"
            value={formData.guardian1Name}
            onChange={(e) => setFormData({ ...formData, guardian1Name: e.target.value })}
          />
          <input
            id="student-edit-guardian1-phone"
            name="student_edit_guardian1_phone"
            className="flex-1 bg-white border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-[#354F38] focus:ring-4 focus:ring-[#354F38]/10 transition"
            placeholder="010-0000-0000"
            value={formData.guardian1Phone}
            onChange={(e) =>
              setFormData({
                ...formData,
                guardian1Phone: formatPhoneNumber(e.target.value),
              })
            }
          />
        </div>
      </div>

      <div className="col-span-12">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">
          보호자2 <span className="text-gray-300 font-normal">(선택)</span>
        </label>
        <div className="flex gap-2">
          <input
            id="student-edit-guardian2-name"
            name="student_edit_guardian2_name"
            className="w-24 bg-white border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-[#354F38] focus:ring-4 focus:ring-[#354F38]/10 transition text-center"
            placeholder="관계"
            value={formData.guardian2Name}
            onChange={(e) => setFormData({ ...formData, guardian2Name: e.target.value })}
          />
          <input
            id="student-edit-guardian2-phone"
            name="student_edit_guardian2_phone"
            className="flex-1 bg-white border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-[#354F38] focus:ring-4 focus:ring-[#354F38]/10 transition"
            placeholder="010-0000-0000"
            value={formData.guardian2Phone}
            onChange={(e) =>
              setFormData({
                ...formData,
                guardian2Phone: formatPhoneNumber(e.target.value),
              })
            }
          />
        </div>
      </div>

      <div className="col-span-12">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">학교/직장</label>
        <AppInput
          id="student-edit-school"
          name="student_edit_school"
          value={formData.school}
          onChange={(e) => setFormData({ ...formData, school: e.target.value })}
          onClear={() => setFormData({ ...formData, school: "" })}
          placeholder="학교 또는 직장명"
        />
      </div>

      <div className="col-span-12 sm:col-span-6">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">부서</label>
        <div className="relative">
          <CustomSelect
            options={[
              ...allDepartments.map((d) => ({ value: d, label: d })),
              { value: "custom", label: "기타 (직접 입력)" },
            ]}
            value={
              allDepartments.some(
                (d) => d === String(formData.grade || "").normalize("NFC").trim()
              )
                ? formData.grade
                : "custom"
            }
            onChange={(val) => {
              if (val === "custom") {
                setFormData({ ...formData, grade: "" });
              } else {
                setFormData({ ...formData, grade: val });
              }
            }}
            placeholder="부서 선택"
            triggerClassName="w-full bg-white border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none transition flex justify-between items-center"
            theme={theme}
          />
        </div>
        {!allDepartments.some(
          (d) => d === String(formData.grade || "").normalize("NFC").trim()
        ) && (
          <input
            id="student-edit-grade-custom"
            name="student_edit_grade_custom"
            className="w-full mt-2 bg-yellow-50 border border-yellow-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-yellow-400 transition animate-fade-in text-yellow-800 placeholder-yellow-800/50"
            placeholder="부서를 직접 입력하세요"
            value={formData.grade}
            onChange={(e) => setFormData({ ...formData, grade: e.target.value })}
          />
        )}
      </div>
      <div className="col-span-12 sm:col-span-6">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">반 (선택)</label>
        <AppInput
          id="student-edit-class"
          name="student_edit_class"
          placeholder="예: 1반, 사랑반"
          value={formData.class}
          onChange={(e) => setFormData({ ...formData, class: e.target.value })}
          onClear={() => setFormData({ ...formData, class: "" })}
        />
      </div>

      <div className="col-span-12">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">주소</label>
        <AppInput
          id="student-edit-address"
          name="student_edit_address"
          value={formData.address}
          onChange={(e) => setFormData({ ...formData, address: e.target.value })}
          onClear={() => setFormData({ ...formData, address: "" })}
          placeholder="주소를 입력하세요"
        />
      </div>

      <div className="col-span-12">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">신앙상태</label>
        <div className="grid grid-cols-3 gap-2 w-full mt-2">
          {[
            {
              label: "초신자",
              active: "bg-amber-400 text-white border-amber-400",
              inactive: "bg-white text-amber-500 border-amber-200 hover:bg-amber-50",
            },
            {
              label: "기존신자",
              active: "bg-[#354F38] text-white border-[#354F38]",
              inactive: "bg-white text-[#354F38] border-[#354F38]/30 hover:bg-[#354F38]/5",
            },
            {
              label: "양육중",
              active: "bg-blue-500 text-white border-blue-500",
              inactive: "bg-white text-blue-500 border-blue-200 hover:bg-blue-50",
            },
            {
              label: "시험듦",
              active: "bg-rose-500 text-white border-rose-500",
              inactive: "bg-white text-rose-500 border-rose-200 hover:bg-rose-50",
            },
            {
              label: "장기결석",
              active: "bg-gray-400 text-white border-gray-400",
              inactive: "bg-white text-gray-400 border-gray-200 hover:bg-gray-50",
            },
          ].map((item) => (
            <button
              type="button"
              key={item.label}
              onClick={() => setFormData({ ...formData, faithState: item.label })}
              className={`w-full py-2.5 text-xs font-bold rounded-xl border transition shadow-sm flex items-center justify-center ${
                formData.faithState === item.label ? item.active : item.inactive
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="col-span-12">
        <label className="text-xs font-bold text-gray-500 ml-1 mb-1.5 block">비고</label>
        <textarea
          id="student-edit-notes"
          name="student_edit_notes"
          className="w-full bg-[#F9F9F8] border border-gray-200 p-3.5 rounded-2xl font-medium focus:outline-none focus:border-[#354F38] transition resize-none h-32 leading-relaxed"
          value={formData.notes || ""}
          onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
          placeholder="특이사항을 입력하세요"
        />
      </div>
    </div>
  );
}
